import anime from 'animejs'
import Draggabilly from 'draggabilly';
import Accordion from 'accordion-js';
// import 'accordion-js/dist/accordion.min.css';
import 'sticksy';
import FormValidator from '@yaireo/validator'

import BB_Header from './header';
import BB_Archive_Product from './archive_product';
import BB_Cart from './cart';

export default class BB_Single_Product {
    constructor() {

        let accordion = jQuery('.accordion-container')
        console.log(accordion);
        if (accordion.length) {
            BB_Single_Product.accordion = new Accordion('.accordion-container', {
                onOpen: (currElement) => {
                    BB_Single_Product.refresh_sticky()
                }
            })
        }
        BB_Single_Product.stickyEl = new Sticksy('.ob-product-content', {
            topSpacing: 18,
        })

        BB_Single_Product.init()

        // stickyEl.onStateChanged = function (state) {
        //     // your handler here
        //     if (state === 'fixed') alert('it is fixed!')
        // }

        // stickyEl.onStateChanged = function (state) {
        //     if (state === 'fixed') stickyEl.nodeRef.classList.add('widget--sticky')
        //     else stickyEl.nodeRef.classList.remove('widget--sticky')
        // }

        //    console.log(this.accordion);

        // this.init()

    }
    static init() {
        console.log('single_product.js init');

        BB_Single_Product.refresh_sticky()

        jQuery(document).on('click', '.ob-product-sizes li', BB_Single_Product.change_size)
        jQuery(document).on('click', '.ob-cart-btn', BB_Single_Product.add_to_cart)

        // gift card page
        BB_Single_Product.validate_gift_card_form()
        jQuery(document).on('click', '.ob-gift-cart-btn', BB_Single_Product.add_gift_to_cart)

        BB_Single_Product.quantity_form()
    }
    static refresh_sticky() {
        console.log('single_product.js refresh');

        let sticky = BB_Single_Product.stickyEl
        sticky.hardRefresh()
    }
    static change_size() {
        const $ = jQuery;
        const $this = $(this);
        const this_variation_id = $this.data('variation-id');
        const this_stock_quantity = $this.data('stock-quantity');

        $('.ob-product-sizes li').removeClass('ob-active')
        $this.addClass('ob-active')

        $('.ob-quantity').attr('data-stock-quantity', this_stock_quantity)
        $('.qty-single').val(1).attr('value', 1)

        $('.ob-cart-btn, .ob-gift-cart-btn').attr('data-variation-id', this_variation_id)
        $('.ob-product-cart').removeClass('ob-disabled')
    }
    static quantity_form() {
        const $ = jQuery;

        $(document).on('click', '.qty-plus-single', function (e) {
            const $this = $(this);
            let $input = $('.qty-single');
            let val = parseInt($input.val());
            let stock_quantity = $this.closest('.ob-quantity').data('stock-quantity');
            let new_val = (val + 1);
            // let cart_product = $this.closest('.ob-cart-menu-product');

            if (new_val <= stock_quantity) {
                $input.val(new_val).on('change');
                $input.attr('value', new_val);
            }
        });

        $(document).on('click', '.qty-minus-single', function (e) {
            const $this = $(this);
            let $input = $('.qty-single');
            let val = parseInt($input.val());
            // let cart_product = $this.closest('.ob-cart-menu-product');

            if (val > 1) {
                let new_val = val - 1;

                $input.val(new_val).on('change');
                $input.attr('value', new_val);
            }
        });
    }
    static add_to_cart(e) {
        e.preventDefault()

        let $this = jQuery(e.target)
        let product_id = $this.data('product-id')
        let variation_id = $this.data('variation-id')
        let quantity = jQuery('.qty-single').attr('value')

        // console.log(e.target);
        console.log(product_id);
        console.log(variation_id);
        console.log(quantity);

        jQuery('.ob-product-cart').addClass('ob-disabled')

        BB_Header.cart_start_loading()
        BB_Cart.start_loading()

        BB_Archive_Product.add_to_cart_ajax([product_id, variation_id, quantity], null)


        // ajax refresh ob-product-content

        // quantity
        // change active stock quantity - if stock 0, change li.ob-active to .out-stock

    }
    static validate_gift_card_form() {
        let formId = jQuery('.ob-pwgc-form')
        var validator = new FormValidator();

        [...formId].forEach( el => {
            el.addEventListener('change', function(e){
                let result = validator.checkField(e.target)

                console.log(result);
            }, true);
        });

    }
    static add_gift_to_cart(e) {
        e.preventDefault()

        let $this = jQuery(e.target)
        let product_id = $this.data('product-id')
        let variation_id = $this.data('variation-id')

        let gift_card_to = $this.closest('.ob-product-content').find('.ob-pwgc-to').val()
        let gift_card_from = null
        let gift_card_message = null
         
        // let quantity = jQuery('.qty-single').attr('value')
        // let cart_item_data = {}
        // cart_item_data.pw_gift_card_to = 'test@email.com'
        console.log(gift_card_to.length);
        // console.log(product_id);
        // console.log(variation_id);

        jQuery('.ob-product-cart').addClass('ob-disabled')

        BB_Header.cart_start_loading()
        BB_Cart.start_loading()

        BB_Single_Product.add_gift_to_cart_ajax([product_id, variation_id], [gift_card_to])

        // ajax refresh ob-product-content

        // quantity
        // change active stock quantity - if stock 0, change li.ob-active to .out-stock

    }
    static async add_gift_to_cart_ajax(product_data, form_data) {
        const request_body = {
            security: ajax_object.add_gift_to_cart_nonce,
            action: "add_gift_to_cart_action",
            data: product_data,
            cart_data: form_data
        }
        const request = {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: jQuery.param(request_body)
        }
        try {
            const respose = await fetch(ajax_object.ajax_url, request);
            const response_json = await respose.json();
      
            console.log(response_json);

            if (response_json.success) {

                BB_Cart.refresh()
            }

        } catch (err) {
            console.log(err);
        }
    }
}

